import ReactPlayer from 'react-player';
import { getContentPath, getTenantId } from '@/utils/functions';
import { isVideoItem, playsToEnd } from '../../lib/items';
import { platform } from '@/platform';
import { useStage } from '../stage';
import { SyncedVideo } from './SyncedVideo';

/** An image or video from the library (from the content cache or device storage when stored). */
export const MediaItem = ({
  item,
  single,
  onEnded,
  idleImage,
  startedAtMs,
}) => {
  const stage = useStage();
  const url = platform.media.resolve(
    getContentPath(getTenantId()) + item.file.fileName,
  );
  const className = `${stage.fitClass} absolute top-0 left-0 h-full w-full`;

  if (isVideoItem(item)) {
    // On a wall the timeline drives the video, so every tile shows the same frame.
    if (stage.wall)
      return (
        <SyncedVideo
          url={url}
          className={className}
          startedAtMs={startedAtMs}
          now={stage.now}
        />
      );

    // A natural-length video moves on when it ends, unless it is the only item.
    const toEnd = playsToEnd(item) && !single;
    return (
      <ReactPlayer
        url={url}
        className={className}
        height="100%"
        width="100%"
        playing
        muted
        loop={!toEnd}
        playsinline
        onEnded={toEnd ? onEnded : undefined}
        onError={(err) => console.error('playback error', err)}
        config={{
          file: {
            attributes: {
              preload: 'auto', // ask browser to download ahead
              poster: idleImage, // show poster before playback begins
              crossOrigin: 'anonymous',
            },
          },
        }}
      />
    );
  }

  return (
    <img
      className={className}
      alt="Content"
      onError={(e) => {
        e.target.onerror = null;
        if (idleImage) e.target.src = idleImage;
      }}
      src={url}
    />
  );
};
